import { FC } from 'react';
import { Close, Forward, Save } from '@mui/icons-material';
import { Button, Box, ButtonGroup } from '@mui/material';

interface IModalSaveSection {
  enableSaveAndContinue?: boolean;
  handleCancel: () => void;
  isSaveDisabled?: boolean;
  handleSave?: (saveAndContinue?: any) => void;
  showButtonGroupElevation?: boolean;
  saveButtonIcon?: JSX.Element;
  saveButtonText?: string;
  saveAndContinueButtonText?: string;
  marginTop?: string | number;
}

export const ModalSaveSection: FC<IModalSaveSection> = ({
  enableSaveAndContinue = false,
  handleCancel,
  isSaveDisabled,
  handleSave,
  showButtonGroupElevation = false,
  saveButtonIcon,
  saveButtonText,
  saveAndContinueButtonText,
  marginTop = '2rem'
}) => {
  return (
    <Box marginTop={marginTop}>
      <ButtonGroup disableElevation={!showButtonGroupElevation}>
        <Button
          disabled={isSaveDisabled}
          type={handleSave ? 'button' : 'submit'}
          onClick={e => {
            if (handleSave) {
              handleSave();
            }
          }}
          startIcon={saveButtonIcon || <Save />}
          variant="contained"
          color="primary"
        >
          {saveButtonText || 'Save'}
        </Button>
        {enableSaveAndContinue && (
          <Button
            disabled={isSaveDisabled}
            type={handleSave ? 'button' : 'submit'}
            onClick={e => {
              if (handleSave) {
                handleSave(true);
              }
            }}
            startIcon={<Forward />}
            variant="contained"
            color="primary"
          >
            {saveAndContinueButtonText || 'Save and New'}
          </Button>
        )}
        <Button
          type="button"
          variant="contained"
          startIcon={<Close />}
          color="inherit"
          onClick={handleCancel}
        >
          Cancel
        </Button>
      </ButtonGroup>
    </Box>
  );
};
